<!-- Comments section -->
@for (comment of postComment.commentsList; track comment) {
<article class="media">
  <figure class="media-left">
    <p class="image is-32x32">
      @if (!comment.user_detail.user_icon) {
      <empty-uname
        [userName]="comment.user_detail.full_name"
        [detailHeadProfile]="true"
      ></empty-uname>
      } @if (comment.user_detail.user_icon) {
      <img [src]="profileUrl + comment.user_detail.user_icon" />
      }
    </p>
  </figure>
  <div class="media-content">
    <div class="content">
      <div>
        <strong class="cmt-u-name">{{ comment.user_detail.full_name }}</strong>
        <small class="timeago text-clr-grey">
          {{ comment.createdAt | amTimeAgo }}
        </small>
      </div>
      <div class="cmt-text">
        <small class="">{{ comment.comment }}</small>
        <small class="sub-cmt-link">
          <a class="has-text-info is-small" (click)="openNewSubComment(comment)"
            >Reply @if (comment.subCommentsCount > 0) {
            <span>({{ comment.subCommentsCount }})</span>
            }
          </a>
        </small>
      </div>
    </div>
    <!-- Sub Comment Part -->
    @if (comment.showReply) {
    <div class="field">
      <div class="control is-expanded edit-text-box">
        <input
          type="search"
          class="input text-input"
          inputFocus
          placeholder=" Write your reply here..."
          [(ngModel)]="comment.newSubComment"
          (keyup.enter)="createNewSubComment(comment)"
          (keydown)="keyHandleRely($event)"
        />
        <br />
        @if (comment?.newSubComment?.length >= 250) {
        <div class="errors" style="font-size: 0.9rem; color: red">
          Your comment is too long
        </div>
        }
      </div>
    </div>
    } @if (comment.showReply) {
    <div class="">
      <app-sub-comment [postSubComment]="comment"></app-sub-comment>
    </div>
    }
  </div>
</article>
} @if (postComment.commentsCount > postComment.commentsList.length) {
<div class="mar-10-0">
  <a class="button is-link is-small" (click)="loadMoreComments(postComment)"
    >More</a
  >
</div>
}

<!--  End Comment section -->
